import React, { useEffect, useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../login/AuthContext';
import CardGridTrade from './CardGridTrade';
import HorizontalTradingGrid from './HorizontalTradingGrid';
import ViewTradeOffer from './ViewSaleTradeOffer/ViewTradeOffer';
import translations from "../../utils/language/translations.json";
import { toast } from 'react-toastify';
//Unique to CardGridSell
import { useTranslation } from "react-i18next";
import SeoHelmet from '../../Seo/SeoHelmet';
const GridViewTrade = () => {
  const { t: translate, i18n } = useTranslation(); // Correctly destructure `t` and `i18n`
  const currentLang = i18n.language; // Access the current language
  const t = (key) => translations.GridViewTrade[key][currentLang]; // Adjust the path according to your JSON structure

  const { userId,liveCsrfToken } = useContext(AuthContext);
  const [sellingCards, setSellingCards] = useState([]);
  const [toCompleteListing, setToCompleteListing] = useState([]);
  const [tradeOffer, setTradeOffer] = useState([]);
  const [seeFinishYourListings, setSeeFinishYourListings] = useState(false);
  const [seeTradeOffer, setSeeTradeOffer] = useState(false);
  const [seeCardGrid, setSeeCardGrid] = useState(false);
  
  const fetchCardsData = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradingCards`);
      const json = await res.json();
      setSellingCards(json);
    } catch (error) {
      console.error('Error fetching card data:', error);
    }
  };

  const fetchToCompleteListing = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/tradeplace/getToCompleteListing`, {
        method: 'POST', // Changed from GET to POST to include the body
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken, // Include CSRF token
        },
        credentials: 'include', // Include session for authentication
        body: JSON.stringify({ userId }), // Send userId in the body
      });
  
      if (!res.ok) {
        throw new Error('Failed to fetch to complete listing data');
      }
  
      const json = await res.json();
      setToCompleteListing(json);
    } catch (error) {
      console.error('Error fetching to complete listing data:', error);
      toast.error(t('Error fetching to complete listing data')); // Show an error message to the user
    }
  };
  

  const fetchTradeOffer = async () => {
    try {
      const res = await fetch(`${process.env.REACT_APP_API_BASE}/api/tradeplace/getTradeOffer`, {
        method: 'POST', // Use POST to send the userId in the body
        headers: {
          'Content-Type': 'application/json',
          'x-csrf-token': liveCsrfToken, // Include CSRF token
        },
        credentials: 'include', // Include session for authentication
        body: JSON.stringify({ userId }), // Include the userId in the body
      });
  
      if (!res.ok) {
        throw new Error('Failed to fetch trade offer data');
      }
  
      const json = await res.json();
      setTradeOffer(json);
    } catch (error) {
      console.error('Error fetching trade offer data:', error);
      toast.error(t('Error fetching trade offer data')); // Show an error message to the user
    }
  };
  

  useEffect(() => {
    fetchToCompleteListing();
    fetchCardsData();
    fetchTradeOffer();
  }, []);

  const navigate = useNavigate();

  const enableView = (selection) => {
    switch (selection) {
      case 'finishYourListings':
        setSeeFinishYourListings(!seeFinishYourListings);
        break;
      case 'tradeOffer':
        setSeeTradeOffer(!seeTradeOffer);
        break;
      case 'cardGrid':
        setSeeCardGrid(!seeCardGrid);
        break;
      default:
        break;
    }
  };

  return (
    <section className="grid">
      <SeoHelmet type="trading" />
      <div className="contentfront">
        <div className="justify top-page">
          <div>
            <h1>TradingPlace</h1>
            {/* <button onClick={() => enableView('finishYourListings')}>Finish your listing ({toCompleteListing.length})</button>
            <button onClick={() => enableView('tradeOffer')}>Trade offer ({tradeOffer.length})</button>
            <button onClick={() => enableView('cardGrid')}>Show Trade Room's Cards ({sellingCards.length})</button>

            {seeFinishYourListings && toCompleteListing.length > 0 && (
              <HorizontalTradingGrid data={toCompleteListing} userId={userId}liveCsrfToken={liveCsrfToken} t={t} />
            )}
            {seeTradeOffer && tradeOffer.length > 0 && (
              <ViewTradeOffer tradeOffers={tradeOffer} userId={userId} liveCsrfToken={liveCsrfToken} t={t}/>
            )} */}
            {<CardGridTrade cards={sellingCards} />}
          </div>
        </div>
      </div>
    </section>
  );
};

export default GridViewTrade;
